import React from 'react';
import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
  root: {

  }
});

function Monitor_Allocate(props) {
  const { classes } = props;
  return (
    <>
      <div className={classes.root}>
        전체 로그인/배분 모니터링 페이지 입니다.
      </div> 
    </>
  );
}
export default withStyles(styles)(Monitor_Allocate);